import { Component, OnInit } from '@angular/core';
import {  MatSnackBar } from '@angular/material';
import 'hammerjs';
import {CommonService } from '../../services/common.service';
import {AuthService} from '../auth.service';
import { NgForm } from '@angular/forms';
import { FormBuilder, Validators, FormGroup, ValidatorFn, AbstractControl, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { CartService } from '../../services/cart.service';
import { Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {
  bio= 'aboutme';
  gender= 'mf';
  role_id= 2;
  dob= '00/00/0000';
  action: any;
  remember_token= '1';
  image= 'avatar-1577909_960_720.png';
  show= false;
  msg = '';
  registrationform: any;
  em: any;
  ipadd = '0.0.0.0';
  source: any;
  loading: any;
  redirecrcheckflag: number;
  tempuserid: any;
  tempcartdata: any;
  currentusercartdata: any;
  temparray = [];
  temcartdatalength: any;
  constructor(private commonService: CommonService, public form: FormBuilder,
  private authService: AuthService, private router: Router, public snackBar: MatSnackBar,
  private cartService:CartService,@Inject(PLATFORM_ID) private platformId: Object) {
    this.source = 'WebApp';
    this.tempuserid = this.authService.checkUserTempData();
    this.registrationform = this.form.group({
      'name': new FormControl('', Validators.required),
      'email': new FormControl('', [Validators.required,
        Validators.pattern(/^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i)]),
      'mobile': new FormControl('', [Validators.required, Validators.minLength(10)]),
      'password': new FormControl('' , [Validators.required]),
      'cnfmPass': new FormControl ('' , [Validators.required, this.equalto('password')])
      });
      this.redirecrcheckflag = this.commonService.getActivatepath();
      this.gettemproraryuserCartItem();
  }
  ngOnInit() {
    this.commonService.getIpAddress().subscribe(data => {
      this.ipadd = data.ip;
    });
  }
  gettemproraryuserCartItem() {
    this.cartService.getUserCartItems(this.tempuserid)
    .subscribe((x)=>{
      this.tempcartdata = x;
    })
  }
  equalto(field_name): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} => {
    const input = control.value;
    const  isValid = control.root.value[field_name] === input
// Add a comment to this line
    if (!isValid) {
      return { 'equalTo': {isValid} }
    } else {
      return null;
    }
  };
  }
   doSignup() {
     this.loading = true;
     if (this.ipadd === undefined) {
      this.ipadd = '0.0.0.0' ;
    }
    this.authService.signUp(this.registrationform.name, this.registrationform.email, this.registrationform.mobile,
      this.bio, this.image, this.gender, this.role_id, this.dob, this.remember_token, this.registrationform.password,
    this.ipadd, this.source)
    .subscribe(result => {
      if (result === true) {
        if (isPlatformBrowser(this.platformId)) {
        localStorage.removeItem('activatepath');
        this.msg = 'You have Successfully registered';
        this.openSnackBar();
        localStorage.removeItem('activatepath');
        this.authService.setRoleId(2);
        this.checkingTemporarycart();
        }
        }
    },
  (err) => {
    this.loading = false;
    this.msg = 'This email and mobile is already registered';
    this.openSnackBar()
  });
  }
  openSnackBar() {
    this.snackBar.open(this.msg , this.action, {
    duration: 4000,
    });
  }
  checkingTemporarycart() {
    if (this.tempcartdata.length == 0) {
      this.loading = false;
      this.movetoSpecificPath();
    } else {
      this.cartService.getUserData(this.registrationform.email)
                  .subscribe(
                      (x) => {
                      const uid = x[0].id;
                      this.getCurrentuserCartItem(uid);
           });
       }
  }
  getCurrentuserCartItem(uid) {
    this.cartService.getUserCartItems(uid)
    .subscribe((x)=>{
      this.currentusercartdata = x;
      if (this.currentusercartdata.length == 0) {
        this.updateUserIdIntoCartDb(uid);
       } else {
         this.updateCartQuantityIntodb(uid);
       }
    })
  }
  updateUserIdIntoCartDb(uid) {
    let tempcartlength = this.tempcartdata.length
    for (let i=0 ; i < this.tempcartdata.length ;i++) {
      this.cartService.updateUseridInCart(this.tempcartdata[i].id, uid)
      .subscribe(
        (x) => {
          tempcartlength = tempcartlength - 1;
          if(tempcartlength == 0) {
            this.loading = false;
            this.movetoSpecificPath();
          }
        });
    }
  }
  updateCartQuantityIntodb(uid) {
    this.temcartdatalength = this.tempcartdata.length;
    this.temparray =[];
    for(let i = 0 ;i <this.tempcartdata.length; i++) {
      let temindex = this.tempcartdata[i].id;
      let sku = this.tempcartdata[i].sku;
      let flag  = 0;
      let index = this.tempcartdata[i].id;
      let quantity = this.tempcartdata[i].quantity;
      let payabl =  this.tempcartdata[i].payable;
     for (let i = 0; i < this.currentusercartdata.length; i++) {
           if (this.currentusercartdata[i].sku === sku) {
             flag = flag +1;
             quantity = quantity + this.currentusercartdata[i].quantity;
             payabl = payabl + this.currentusercartdata[i].payable;
             index = this.currentusercartdata[i].id;
           }
         }
         if (flag > 0) {
           this.temparray.push(temindex);
          this.UpdateCartDeatail(index, quantity,  payabl)
         }else {
           this.updateOnlyuserId(uid,index);
         }
      }
     }
     updateOnlyuserId(uid, index){
      this.cartService.updateUseridInCart(index, uid)
      .subscribe(
        (x) => {
          this.temcartdatalength = this.temcartdatalength - 1;
          if (this.temcartdatalength == 0) {
          //  this.deleteTempraryusercart();
          this.movetoSpecificPath();
          }
        });
     }
     UpdateCartDeatail(index, quantity,  paybl) {
       this.cartService.updateUserQuantityIncart(index,quantity , paybl)
         .subscribe(
          (x) => {
            this.temcartdatalength = this.temcartdatalength - 1;
            if (this.temcartdatalength == 0) {
              this.deleteTempraryusercart();
            }
          });
     }
     deleteTempraryusercart() {
      let temparraylength = this.temparray.length;
      for(let i = 0 ;i <this.temparray.length; i++) {
       this.cartService.deleteCart(this.temparray[i])
       .subscribe(
         (x) =>{
          temparraylength = temparraylength - 1;
          if (temparraylength == 0) {
            this.loading = false;
            this.temparray = [];
            this.movetoSpecificPath();
          }
         });
        }
     }
  movetoSpecificPath() {
    if (isPlatformBrowser(this.platformId)) {
    localStorage.removeItem('idata');
    if (this.redirecrcheckflag === 0) {
      this.router.navigate(['']);
    } else if (this.redirecrcheckflag === 2) {
      this.router.navigate(['/store/checkout']);
    } else if (this.redirecrcheckflag === 3) {
      this.router.navigate(['/pulse/onlinedoctors']);
    }else if (this.redirecrcheckflag === 4) {
      this.router.navigate(['/petadoption/formfillup']);
    }else if (this.redirecrcheckflag === 5) {
      const temp = localStorage.getItem('adopreq');
      localStorage.removeItem('adopreq');
      this.router.navigate(['/petadoption/adoptionrequest/' + temp]);
    }else if (this.redirecrcheckflag === 6) {
      this.router.navigate(['/forum/asktovet']);
    }else if (this.redirecrcheckflag === 7) {
      this.router.navigate(['/pulse/doctor']);
    }else if (this.redirecrcheckflag === 8) {
      this.router.navigate(['/pulse/setreminder']);
    } else if (this.redirecrcheckflag === 9) {
      this.router.navigate(['/nest/booking']);
    } else {
      this.router.navigate(['']);
    }
  }
  }

  isANumber(str) {
    return !/\D/.test(str);
  }
}
